// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sZIWcCLM7pAQi7g8eY_c{height:80%}", "",{"version":3,"sources":["webpack://./src/App/components/useEntities/useMoveSelectionsToTarget.module.scss"],"names":[],"mappings":"AAAA,sBACE,UAAA","sourcesContent":[".highnote-move-selection-paper {\n  height: 80%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"highnote-move-selection-paper": "sZIWcCLM7pAQi7g8eY_c"
};
export default ___CSS_LOADER_EXPORT___;
